var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriorityHighlights({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 608,
    height: 608,
    viewBox: "0 0 608 608",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8H578C590.15 8 600 17.8497 600 30V161.167V608",
    stroke: "#18FEFE",
    strokeOpacity: 0.4,
    strokeWidth: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityHighlights);
export default __webpack_public_path__ + "static/media/priority-highlights.9cd3ee66395ea116878f135b857d616b.svg";
export { ForwardRef as ReactComponent };